<template>
  <div>
    <div class="decription-wrapper" v-loading="loading">
      <div
        v-if="readonly"
        v-html="$sanitize(description)"
        class="decription-text primary"
      ></div>
      <form v-else novalidate id="projectForm">
        <input type="hidden" name="module" value="Project" />
        <input type="hidden" name="action" value="Save" />
        <input type="hidden" name="record" :value="item.id_name.value" />
        <input type="hidden" name="description" :value="description" />
        <Editor
          :autofocus="true"
          :disabled="fieldDisabled"
          :value="description || ''"
          @change="changeText($event)"
          class="description-editor"
        />
      </form>
    </div>
    <div v-if="!readonly && openCollapse">
      <Button
        class="description-button"
        buttonText="Сохранить"
        @click="saveText"
        buttonSize="big"
        buttonColor="blue"
        hasLeftIcon
        iconName="CircleOk"
      />
      <Button
        class="description-button"
        buttonText="Отменить"
        @click="changeMode"
        buttonSize="big"
        buttonColor="transparent"
        hasLeftIcon
        iconName="CircleCross"
      />
    </div>
    <Button
      v-else-if="openCollapse && false"
      class="description-button"
      buttonText="Редактировать"
      :disabled="fieldDisabled"
      @click="changeMode"
      buttonSize="big"
      buttonColor="blue"
      hasLeftIcon
      iconName="Edit"
    />
  </div>
</template>
<script>
import { mixin } from '@/utils/mixins';
import { getController } from '@/controllers/request.js';
import Button from 'Elements/Button/Button';
import Editor from 'Elements/Editor/Editor';

export default {
  mixins: [mixin],
  components: {
    Button,
    Editor
  },
  data() {
    return {
      description: this.formatHtml(this.item.value) || '',
      editorError: false,
      loading: false
    };
  },
  props: {
    readonly: Boolean,
    item: Object,
    openCollapse: Boolean
  },
  computed: {
    fieldDisabled() {
      return this.item.disabled || this.item.visibility == 'disabled';
    },
    fieldRequired() {
      return this.item.required;
    },
    defaultText() {
      return 'нет данных';
    }
  },
  methods: {
    changeText(data) {
      this.editorError = this.fieldRequired && !data;
      this.description = data;
    },
    changeMode: function () {
      if (this.fieldDisabled) return;
      this.$emit('set-mode', !this.readonly);
    },
    saveText: function () {
      this.editorError = this.fieldRequired && !this.description;
      if (this.fieldRequired && !this.description) return;

      this.loading = true;

      let url = '/' + this.item.save_url + '&description=' + this.description;

      getController({ url })
        .then(resp => {
          if (resp.data) {
            this.$emit('update-project', this.description);
          }
        })
        .catch(err =>
          this.catchError(
            err,
            'Возникла ошибка отправки данных формы. Попробуйте еще раз.',
            'save form'
          )
        )
        .finally(() => {
          this.loading = false;
          this.$emit('set-mode', !this.readonly);
        });
    }
  },
  watch: {
    error(val) {
      this.editorError = val;
    }
  }
};
</script>
<style lang="scss" scoped>
.description-button {
  margin-top: 24px;
  padding: 0;
  width: auto;

  & ::v-deep .button-content {
    margin: 0 8px;
  }
}

.decription-wrapper {
  color: $black-190;
  font-size: 14px;
  line-height: 24px;
}

.decription-text {
  & ::v-deep ul > li {
    list-style: disc;
    margin-left: 16px;
  }
}

.description-editor {
  width: 400px;
  padding: 0;

  & ::v-deep * {
    margin: 0 !important;
  }
}
</style>
